
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"57","height":"57","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#56BDD2","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M51.99 6.68h-1.67V5.01A5.015 5.015 0 0045.31 0a5.015 5.015 0 00-5.01 5.01v1.67h-6.679V5.01A5.015 5.015 0 0028.611 0a5.015 5.015 0 00-5.01 5.01v1.67H16.7V5.01A5.015 5.015 0 0011.69 0a5.015 5.015 0 00-5.01 5.01v1.67H5.01A5.015 5.015 0 000 11.69v40.3A5.015 5.015 0 005.01 57h46.98A5.015 5.015 0 0057 51.99v-40.3a5.015 5.015 0 00-5.01-5.01zm-8.35-1.67c0-.921.75-1.67 1.67-1.67.921 0 1.67.749 1.67 1.67v6.68c0 .92-.749 1.67-1.67 1.67-.92 0-1.67-.75-1.67-1.67V5.01zm-16.699 0c0-.921.75-1.67 1.67-1.67.921 0 1.67.749 1.67 1.67v6.68c0 .92-.749 1.67-1.67 1.67-.92 0-1.67-.75-1.67-1.67V5.01zm-16.921 0c0-.921.749-1.67 1.67-1.67.92 0 1.67.749 1.67 1.67v6.68c0 .92-.75 1.67-1.67 1.67-.921 0-1.67-.75-1.67-1.67V5.01zm43.64 46.98c0 .921-.749 1.67-1.67 1.67H5.01c-.921 0-1.67-.749-1.67-1.67V23.602h50.32V51.99zm0-31.728H3.34v-8.573c0-.92.749-1.67 1.67-1.67h1.67v1.67a5.015 5.015 0 005.01 5.01 5.015 5.015 0 005.01-5.01v-1.67h6.902v1.67a5.015 5.015 0 005.01 5.01 5.015 5.015 0 005.01-5.01v-1.67H40.3v1.67a5.015 5.015 0 005.01 5.01 5.015 5.015 0 005.01-5.01v-1.67h1.67c.92 0 1.67.75 1.67 1.67v8.573z"}}),_c('path',{attrs:{"d":"M49.316 27H8.684C7.754 27 7 27.736 7 28.643v19.714C7 49.264 7.754 50 8.684 50h40.632c.93 0 1.684-.736 1.684-1.643V28.643c0-.907-.754-1.643-1.684-1.643zM17.102 46.714h-6.735v-6.571h6.735v6.571zm0-9.857h-6.735v-6.571h6.735v6.571zm10.327 9.857h-6.96v-6.571h6.96v6.571zm0-9.857h-6.96v-6.571h6.96v6.571zm10.102 9.857h-6.735v-6.571h6.735v6.571zm0-9.857h-6.735v-6.571h6.735v6.571zm10.102 9.857h-6.735v-6.571h6.735v6.571zm0-9.857h-6.735v-6.571h6.735v6.571z"}})])])
          )
        }
      }
    